const formatDimensions = (
    width?: number | null,
    depth?: number | null,
    height?: number | null
): string | null => {
    const dims: { label: string; value: number | null | undefined }[] = [
        { label: "szer", value: width },
        { label: "gł", value: depth },
        { label: "wys", value: height },
    ];

    const presentDims = dims.filter(
        (d) => d.value !== null && d.value !== undefined && d.value !== 0
    );

    if (presentDims.length === 0) return null;

    const valuesStr = presentDims.map((d) => d.value).join("/");
    const labelsStr = presentDims.map((d) => d.label).join("/");

    return `${valuesStr} (${labelsStr})`;
};

const DimensionHelper = {
    formatDimensions,
};

export default DimensionHelper;